export default "__VITE_ASSET__Dlc$iE_5__"